<script generics="T" lang="ts">
	import { Icon, SpinnerLoader } from '@repo/ui'
	import { Tooltip } from '@repo/ui'
	import { Check } from '@steeze-ui/heroicons'
	import { fade } from 'svelte/transition'

	interface Props {
		name: string
		value: T
		group: T
		label?: string
		small?: boolean
		required?: boolean
		disabled?: boolean
		full?: boolean
		tooltip?: string | null
		loading?: boolean
		onchange?: (Event) => void
		onselect?: (Event) => void
	}

	let {
		name,
		value,
		group = $bindable(),
		label,
		required = false,
		disabled = false,
		full = false,
		tooltip = null,
		onchange = null,
		onselect = null,
		small = false,
		loading = false,
	}: Props = $props()

	let isChecked = $derived(group === value)
	let id = $derived(`${name}-${value}`)
</script>

<label
	class="relative -mr-px
    flex {full
		? 'grow justify-center'
		: ''} shrink-0 cursor-pointer truncate border first:rounded-l-md last:rounded-r-md hover:z-10
    {isChecked
		? 'border-primary-500 bg-primary-100 text-primary-500 dark:bg-primary-900 dark:text-primary-100 z-10'
		: 'hover:bg-primary-50 dark:hover:bg-primary-900 border-gray-200 dark:border-gray-700'}
    {disabled
		? 'pointer-events-none border-gray-600'
		: 'hover:border-primary-500 dark:hover:border-primary-500'}
		{small ? 'px-2 md:px-3' : 'px-3  md:px-5'}
  "
	for={id}
>
	<input
		{id}
		{name}
		class="pointer-events-none absolute inset-0 opacity-0"
		{disabled}
		{onchange}
		{onselect}
		{required}
		type="radio"
		{value}
		bind:group
	/>
	<span class="inline-flex items-center {small ? 'h-8 text-sm' : 'h-10 gap-2'}">
		{#if isChecked}
			<div class="flex {small ? 'pr-1' : 'pr-2'}" in:fade>
				{#if loading}
					<SpinnerLoader />
				{:else}
					<Icon small src={Check} />
				{/if}
			</div>
		{/if}
		{label}

		{#if tooltip}
			<Tooltip small>
				{tooltip}
			</Tooltip>
		{/if}
	</span>
</label>
